// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/carousel/style/index.less
// module id = 1082
// module chunks = 0